<div class="page">
  <div class="wrapper">

    <div class="info-title">
      <h1>Employee Center</h1>
    </div>

    <div class="flex-row search-section">
      <input  placeholder="Search Employee Name or GID.." type="text" class="input input-lg search-bar" [(ngModel)]="searchFilter" (input)="filterUserList()">
    </div>

    <div class="flex-row filter-section">
      <div class="filter-item">
        <span> Role: </span>
        <select [(ngModel)]="roleFilter" (change)="filterUserList()">
          <option [value]="'All'"> All </option>
          <option [value]="'Admin'"> Admin </option>
          <option [value]="'Inspector'"> Inspector </option>
        </select>
      </div>

      <div class="filter-item">
        <span> Site: </span>
        <select [(ngModel)]="siteFilter" (change)="filterUserList()">
          <option [value]="'All'"> All </option>
          <option [value]="'Flanders'"> Flanders </option>
          <option [value]="'Swords'"> Swords </option>
          <option [value]="'Llanberis'"> Llanberis </option>
          <option [value]="'Las Angeles'"> Los Angeles </option>
        </select>
      </div>
    </div>

    <div class="content-section">

      <div class="content-header">
        <ul class="flex-row">
          <li class="flex-2 content-cell" (click)="sortUserList('surName')">Employee Name
            @if (sortFilter === 'surName') {
              <img alt="" src="../../../assets/sort-arrow.svg" [ngClass]="{'ascending-order': sortAscending}">
            }
          </li>
          <li class="flex-2 content-cell" (click)="sortUserList('gid')">GID
            @if (sortFilter === 'gid') {
              <img alt="" src="./assets/sort-arrow.svg" [ngClass]="{'ascending-order': sortAscending}">
            }
          </li>
          <li class="flex-2 content-cell" (click)="sortUserList('role')">Role
            @if (sortFilter === 'role') {
              <img alt="" src="./assets/sort-arrow.svg" [ngClass]="{'ascending-order': sortAscending}">
            }
          </li>
          <li class="flex-2 content-cell" (click)="sortUserList('site')">Site
            @if (sortFilter === 'site') {
              <img alt="" src="./assets/sort-arrow.svg" [ngClass]="{'ascending-order': sortAscending}">
            }
          </li>
        </ul>
      </div>

      @if ((listLoaded)) {
        <div>
          @for (employee of employeeFilteredList | paginate: { itemsPerPage: 10, currentPage: page }; track employee) {
            <div class="content-main">
              <div class="content-item">
                <ul class="item-main flex-row">
                  <li class="flex-2 content-cell">{{employee.user.preferredSN || employee.user.surName}}, {{employee.user.nickName || employee.user.firstName}} </li>
                  <li class="flex-2 content-cell">{{employee.gid}}</li>
                  <li class="flex-2 content-cell">{{employee.role}}</li>
                  @if (employee.site !='Las Angeles') {
                    <li class="flex-2 content-cell">{{employee.site}}</li>
                  }
                  @if (employee.site =='Las Angeles') {
                    <li class="flex-2 content-cell">Los Angeles</li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="loading-container">
          <div class="flex-row spinner">
            <mat-progress-spinner mode="indeterminate" diameter="150"></mat-progress-spinner>
          </div>
          <div class="flex-row message">
            <h2>Loading Employees...</h2>
          </div>
        </div>
      }


      <pagination-controls (pageChange)="page = $event"></pagination-controls>

    </div>

    <div class="button button-secondary" (click)="addEmployee()"> Add / Update Employee </div>

  </div>
</div>
